import { dateSorter, entityNameSorter, getProp, periodRenderer } from '@lib/generic.utils'
import { agPriceCol, checkboxCol } from '@/ag-grid/ag-columns'
import { notAnyPriceCheck } from '@/ag-grid/utils/notAnyValue'

export const options = {
  computed: {
    options() {
      const statusCol = {
        headerName: 'Status',
        field: 'status'
      }

      const purchaseOrderRefCol = {
        headerName: 'Purchase order reference',
        field: 'member_purchase_order_reference',
        cellRenderer: params => `${params.value || 'Add reference'}`,
        editable: true,
        cellClass: ['editable-cell'],
        cellEditorFramework: 'TextEditor'
      }

      const lastYearsPriceField = this.isPlaceOrders ? 'price' : 'price_last_period'
      const lastYearsCurrencyField = this.isPlaceOrders ? 'currency' : 'currency_last_period'

      return {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        columnDefs: [
          checkboxCol(),

          {
            headerName: 'Publisher',
            field: 'publisher',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },

          {
            headerName: 'Product',
            field: 'name'
          },

          {
            headerName: 'Subscription period',
            field: 'start_date',
            type: 'centerAligned',
            comparator: dateSorter,
            cellRenderer: params => periodRenderer(params.data)
          },

          ...(this.isPlaceOrders ? [statusCol] : []),

          {
            headerName: 'Type',
            field: 'type',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },

          ...(this.isPlaceOrders ? [purchaseOrderRefCol] : []),

          agPriceCol("Last year's price", lastYearsPriceField, {
            cellRenderer: params => notAnyPriceCheck(params, lastYearsCurrencyField)
          })
        ],
        domLayout: 'autoHeight'
      }
    }
  }
}
